import type {
  ImportSpreadsheetRequest,
  ImportSpreadsheetResponse,
} from '@snap-types/actions/import-spreadsheet';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const [importSpreadsheet, useImportSpreadsheetMutation] = injectMutation<
  ImportSpreadsheetRequest,
  ImportSpreadsheetResponse
>(`${QUOTE_BUILDER_SLICE_NAME}/importSpreadsheet`, ({ params, body }) => ({
  url: buildSnapQuoteUrl(
    params.siteCode,
    params.snapQuoteUuid,
    `import-spreadsheet`,
  ),
  method: 'POST',
  body,
}));
